import { createSelector } from 'reselect';
import { RootState } from '@redux/store';

export const sharedPrototypeStoreSelector = (state: RootState) => state.sharedPrototypeStore;

export const sharedPrototypeTokenDataSelector = createSelector(
  sharedPrototypeStoreSelector,
  (sharedPrototypeStore) => sharedPrototypeStore.tokenData,
);
